/**
 * @desc 创建应收账单
 */
const URL = "/rantion-business";
import http, { updateResponse } from "@/http";
export function request(body: defs.business.PaymentOrderRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/oms/paymentOrder/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
